'use strict';

export default function searchModePresentation () {
    let $modePicker = $('.js-search-view-option'),
        $modeTarget = $('.js-search-view-part'),
        $objects = $('.js-search-object'),
        $paggination = $('.js-pagination');

    if (
        !$modePicker.length ||
        !$modeTarget.length
    ) {
        return;
    }

    let changeViewMode = (mode) => {
        switch(mode) {
            case 'list-map':
                $modeTarget
                    .removeClass('col-md-12 hidden-lg hidden-md')
                    .addClass('col-md-6');

                $objects.removeClass('expanded');

                $paggination.removeClass('invisible');

                $(window).trigger('gMap:refreshMap');
                $(window).trigger('gMap:centerMap');
                break;
            case 'list':
                $modeTarget
                    .filter('[data-mode="list"]')
                        .removeClass('col-md-6 hidden-lg hidden-md')
                        .addClass('col-md-12')
                    .end()
                    .filter('[data-mode="map"]')
                        .removeClass('col-md-6')
                        .addClass('hidden-md hidden-lg');

                $objects.addClass('expanded');

                $paggination.removeClass('invisible');
                break;
            case 'map':
                $modeTarget
                    .filter('[data-mode="map"]')
                        .removeClass('col-md-6 hidden-lg hidden-md')
                        .addClass('col-md-12')
                    .end()
                    .filter('[data-mode="list"]')
                        .removeClass('col-md-6')
                        .addClass('hidden-lg hidden-md');

                $objects.removeClass('expanded');

                $paggination.addClass('invisible');

                $(window).trigger('gMap:refreshMap');
                $(window).trigger('gMap:centerMap');
                break;
        }
    };

    $modePicker.on('click', function (e) {
        e.preventDefault();

        changeViewMode($(this).attr('data-mode-type'));
    });
}
